import { bemName } from "../util/bemName";

import bag from "../res/images/bag.png";
import "./Bag.scss";
import { useOrderUuid } from "@/stores/orderIdStore";
import { useNewOrder } from "@/queries/order/useNewOrder";

type BagProps = {
  block?: string;
};

export const Bag = ({ block }: BagProps) => {
  const orderUuid = useOrderUuid();
  const { data: newOrder, error } = useNewOrder({
    uuid: orderUuid,
    queryConfig: {
      enabled: !!orderUuid,
      staleTime: 1000 * 60 * 60,
    },
  });

  const blockName = block || "Bag";

  const bagCount = newOrder?.totalCapacityWatts
    ? Math.round(newOrder.totalCapacityWatts / 100)
    : undefined;

  return (
    <div className={bemName(blockName, "bagcontainer")}>
      <img src={bag} height={16} width={16} alt="bag" />
      <div className={bemName(blockName, "bagcontainertext")}>My bag</div>
      <div className={bemName(blockName, "bagcontainertext2")}>{bagCount}</div>
    </div>
  );
};
